import { render, staticRenderFns } from "./DoorphoneForm.vue?vue&type=template&id=48c605d2&scoped=true"
import script from "./DoorphoneForm.vue?vue&type=script&lang=js"
export * from "./DoorphoneForm.vue?vue&type=script&lang=js"
import style0 from "./DoorphoneForm.vue?vue&type=style&index=0&id=48c605d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c605d2",
  null
  
)

export default component.exports